<template>
  <div class="Table">
    <!-- :height="tableHeight" -->
    <el-table
      :height="tableHeight"
      ref="multipleTable"
      :data="tableData"
      v-loading="tableLoading"
      @selection-change="monitorSelected"
      @sort-change="sortChange"
      @cell-click="tableLineClick"
      @row-click="rowClick"
      @select-all="selectAll"
      :span-method="arraySpanMethod"
      :border="false"
      size="small"
      style="font-size:14px;transition: all 0.1s;width:100%;"
      :header-cell-style="{background:'#f8f3ff'}"
      :show-summary="showSummary"
      :sum-text="sumText"
      :summary-method="summaryMethod"
      :highlight-current-row="highlight"
      :stripe="stripe"
      :row-key="rowKey"
      :default-expand-all="expandAll"
      :tree-props="{children: 'children', hasChildren: 'hasChildren'}"
    >
      <el-table-column
        v-if="indexShow"
        fixed="left"
        type="index"
        :align="align"
        label="序号"
        width="50px"
      ></el-table-column>
      <el-table-column
        v-if="radioShow"
        fixed="left"
        :align="align"
        label="单选"
        width="50px"
        type="radio"
      >
        <template slot-scope="scope">
          <el-radio
            :label="scope.$index"
            v-model="radioModel"
            @change.native="getTemplateRow(scope.$index, scope.row)"
          >{{''}}</el-radio>
        </template>
      </el-table-column>
      <el-table-column
        v-if="selectionShow"
        type="selection"
        :align="align"
      ></el-table-column>
      <template v-for="item in tableConfig">
        <el-table-column
          :key="item.prop"
          v-if="item.show"
          :type="item.type"
          :prop="item.prop"
          :label="item.label"
          :sortable="item.sortable"
          :fixed="item.fixed"
          :index="indexMethod"
          :align="item.align"
          :show-overflow-tooltip="item.showOverFlow"
          :width="item.width ? item.width : ''"
        >
          <!-- 模板插槽 -->
          <template slot-scope="scope">
            <div
              style="display:inline-block;"
              v-html="scope.row[item.prop]"
              :class="item.class"
              @click="item.func ? $emit(item.func, scope.row ,scope.column) : false"
            ></div>
          </template>
        </el-table-column>
      </template>
      <template v-for="(item,index) in handleTableConfig">
        <el-table-column
          v-if="item.show"
          fixed="right"
          :label="item.label"
          :key="index"
          :align="align"
          :width="item.width || 200"
        >
          <template slot-scope="scope">
            <el-button
              v-for="i in item.handle"
              :key="i.id"
              :type="i.type"
              :size="i.size"
              :icon="i.icon"
              v-show="judgeHandleStatus(scope.row,i)"
              @click.stop="$emit(i.func,scope.row)"
            >{{i.prop?scope.row[i.prop]:i.text}}</el-button>
          </template>
        </el-table-column>
      </template>
      <div slot="empty">
        <div>
          <img
            src="@/assets/img/table_noData.png"
            width="300"
            height="300"
          />
        </div>
      </div>
    </el-table>
    <div
      class="table-toolBar float-right"
      :class="{'table-toolBar-pageHide': pageHide}"
    >
      <el-pagination
        background
        @size-change="getPageSize"
        @current-change="getPageNumber"
        :disabled="tableLoading"
        :current-page="pageInfo.pageNum"
        :page-sizes="pageSizes"
        :page-size="minitPagesize"
        :layout="pageLayout"
        :total="total"
        v-if="!pageHide"
      ></el-pagination>
      <div v-if="refreshShow === true || exportShow === true">
        <!-- <el-button
          icon="el-icon-refresh "
          @click="refreshTable"
          v-if="refreshShow"
        ></el-button> -->
        <!-- 导出全部 -->
        <el-button
          v-if="exportShow"
          @click="exportAllData"
          icon="el-icon-upload2"
        >导出</el-button>
        <!-- <el-dropdown
          class="avatar-container"
          trigger="click"
          v-if="exportShow"
        >
          <div
            class="avatar-wrapper"
            style="line-height:50px;"
          >
            <el-button>导出
              <i class="el-icon-upload2 el-icon--right"></i>
            </el-button>
          </div>
          <el-dropdown-menu
            class="user-dropdown"
            slot="dropdown"
            v-if="showExport"
          >
            <el-dropdown-item>
              <span @click="exportSelected">导出选中</span>
            </el-dropdown-item>
            <el-dropdown-item>
              <span @click="exportAll">导出全部</span>
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>-->
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'VTable',
  props: {
    tableLoading: {
      type: Boolean,
      default: false,
    },
    indexShow: {
      type: Boolean,
      default: true,
    },
    selectionShow: {
      type: Boolean,
      default: false,
    },
    showExport: {
      type: Boolean,
      default: false,
    },
    tableConfig: {
      type: Array,
      default: () => [],
    },
    handleTableConfig: {
      type: Array,
      default: () => [],
    },
    tableData: {
      type: Array,
      default: () => [],
    },
    total: {
      type: Number,
      default: 15,
    },
    tableHeight: {
      type: [Number, String],
      default: 'auto',
    },
    exportFileName: {
      type: String,
      default: '导出表格',
    },
    align: {
      type: String,
      default: 'center',
    },
    refreshShow: {
      type: Boolean,
      default: true,
    },
    exportShow: {
      type: Boolean,
      default: false,
    },
    pageHide: {
      type: Boolean,
      default: false,
    },
    radioShow: {
      type: Boolean,
      default: false,
    },
    arraySpanMethod: {
      type: Function,
      default: () => {},
    },
    showSummary: {
      type: Boolean,
      default: false,
    },
    sumText: {
      type: String,
      default: '合计',
    },
    summaryMethod: {
      type: Function,
      default: () => {},
    },
    stripe: {
      type: Boolean,
      default: true,
    },
    rowKey: {
      type: String,
      default: 'zanshimeiyou',
    },
    expandAll: {
      type: Boolean,
      default: true,
    },
    highlight: {
      type: Boolean,
      default: false,
    },
    pageInfo: {
      type: Object,
      default: () => ({
        pageSize: 15,
        pageNum: 1,
      }),
    },
    pageSizes: {
      type: Array,
      default: () => [15, 30, 50],
    },
    initPagesize: {
      type: Number,
      default: 15,
    },
    pageLayout: {
      type: String,
      default: 'total, sizes, prev, pager, next, jumper',
    },
  },
  data() {
    return {
      // 如何把pageSize和pageNumber传值父亲
      // pageInfo: {
      //   pageSize: 15,
      //   pageNum: 1,
      //   sortName: '',
      //   sortOrder: 'asc',
      // },
      selecteds: [],
      radioModel: '',
      minitPagesize: this.initPagesize,
    };
  },
  created() {
    this.handleRowShow = true;
  },
  activated() {
    this.$refs.multipleTable.doLayout();
  },
  mounted() {},
  computed: {
  },
  watch: {
    tableData() {
      this.$refs.multipleTable.doLayout();
      // 清空selected
      if (this.radioShow) {
        this.radioModel = '';
        this.getTemplateRow('', []);
      }
    },
  },
  methods: {
    judgeHandleStatus(row, handle) {
      // judgeFunc 操作栏判断显示隐藏
      this.$emit('judgeFunc', row, handle);
      return this.handleRowShow;
    },
    monitorSelected(selection) {
      this.selecteds = selection;
      this.$emit('sendSelecteds', this.selecteds);
    },
    exportAll() {
      if (this.total === 0) {
        this.$message.error('表格中数据为空');
        return;
      }
      // 需要拿到后台所有信息(没有分页信息)
      this.$emit('requestNopageTableInfo');
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => v[j]));
    },
    indexMethod(index) {
      return index + 1;
    },
    sendPageInfo() {
      this.$emit('sendPageInfos', this.pageInfo);
    },
    refreshTable() {
      this.$emit('refreshTable');
    },
    getPageSize(val) {
      this.pageInfo.pageSize = val;
      this.sendPageInfo();
    },
    getPageNumber(val) {
      this.pageInfo.pageNum = val;
      this.sendPageInfo();
    },
    sortChange(column) {
      const newColumn = column;
      if (this.total === 0) {
        this.$message.error('表格中数据为空');
        return;
      }
      if (column.order === 'ascending') {
        newColumn.order = 'asc';
      }
      if (column.order === 'descending') {
        newColumn.order = 'desc';
      }
      this.pageInfo.sortName = column.prop;
      this.pageInfo.sortOrder = column.order;
      this.sendPageInfo();
    },
    tableLineClick(data) {
      this.$emit('tableLineClick', data);
    },
    rowClick(row) {
      // this.$refs.multipleTable.toggleRowSelection(row);
      this.$emit('rowClick', row);
    },
    selectAll(selection) {
      this.$emit('selectAll', selection);
    },
    exportAllData() {
      this.$emit('exportAllData');
    },
    getTemplateRow(index, row) {
      this.$emit('getTemplateRow', index, row);
    },
  },
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.Table {
  // height: 100%;
  min-height: 400px;
  flex: 1;
  display: flex;
  flex-direction: column;
  .el-table {
    display: flex;
    flex-direction: column;
    overflow: auto;
  }
}

/deep/.el-table__body-wrapper {
  flex: 1 !important;
}

.table-toolBar {
  display: flex;
  justify-content: space-between;
  margin-top: 10px;
}
.table-toolBar-pageHide {
  justify-content: flex-end;
}

/deep/ .el-radio__label {
  padding-left: 0;
}
/deep/ .el-table {
  border-radius: 8px;
}
/deep/.el-table th.is-leaf,
/deep/.el-table td {
  border-bottom: 1px solid #e9e9e9;
}
/deep/.el-table--enable-row-transition .el-table__body td {
  border-right: 1px solid #e9e9e9;
}
/deep/.el-table__header-wrapper tbody td,
/deep/.el-table__footer-wrapper tbody td {
  background-color: #f2f7fe;
  border-top: none;
  height: 40px;
  line-height: 40px;
}
/deep/.el-table::before {
  height: 0;
}
</style>
